import React from "react";
import { Route, Routes } from "react-router-dom";
import CentroEquiposPage from "../pages/CentroEquiposPage";

export default function CentroEquiposRoutes() {
  return (
    <Routes>
      <Route path="" element={<CentroEquiposPage />} />
    </Routes>
  );
}
